import { Component, OnInit } from '@angular/core';
import { NgIf, NgFor } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlayerService } from '../../../services/player.service';
import { ApplicationService } from '../../../services/application.service';
import { Player } from '../../../models/Player';
import { CreatePlayerRequest } from '../../../models/createPlayerRequest';
@Component({
  selector: 'app-player-admin',
  standalone: true,
  imports: [NgIf, NgFor, FormsModule],
  templateUrl: './player-admin.component.html',
  styleUrl: './player-admin.component.css'
})
export class PlayerAdminComponent implements OnInit {
  constructor(private applicationService:ApplicationService, private playerService:PlayerService) {}

  containerDisplay:string = 'LIST';
  allPlayers:Array<Player> = [];
  blankCreatePlayerRequest = { firstName: '', lastName: '', email: null, phone: null };
  createPlayerRequest:CreatePlayerRequest = this.blankCreatePlayerRequest;
  showCreatePlayerError:boolean = false;
  blankPlayer:Player = { id:-1,  email: null, phone: null, permissions: [], firstName: '', lastName: ''};
  playerToUpdate:Player = this.blankPlayer;

  ngOnInit(): void {
    this.getAllPlayers();
  }

  async getAllPlayers():Promise<void> {
    this.applicationService.showGlobalSpinner();
    this.allPlayers = await this.playerService.searchPlayers();
    this.applicationService.hideGlobalSpinner();
  }

  async createNewPlayer():Promise<void> {
    this.applicationService.showGlobalSpinner();
    let id = await this.playerService.createPlayer(this.createPlayerRequest)
    if(id > 0)
      this.createPlayerRequest = this.blankCreatePlayerRequest;
    await this.getAllPlayers();
    this.applicationService.hideGlobalSpinner();
    this.containerDisplay = 'LIST';
  }

  async updatePlayer():Promise<void> {
    this.applicationService.showGlobalSpinner();
    let id = await this.playerService.updatePlayer(this.playerToUpdate)
    if(id > 0)
      this.playerToUpdate = this.blankPlayer;
    await this.getAllPlayers();
    this.applicationService.hideGlobalSpinner();
    this.containerDisplay = 'LIST';
  }

  onPhoneInput() {
    const value = this.createPlayerRequest.phone ?? '';
    this.createPlayerRequest.phone =
      value.replace(/[^0-9]/g, '').slice(0, 10);
  }
}
